import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Coupon from '../../../atoms/coupon';
import './coupon-scroll-box.m.css';

class CouponScrollBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      clickedCouponCode: ''
    };
    this.couponOnClick = this.couponOnClick.bind(this);
  }

  couponOnClick(selectedPlanId, couponCode, setAppliedCoupon, handleInvalidCoupon) {
    if (selectedPlanId && couponCode) {
      this.props.disablePlanSelection && this.props.disablePlanSelection();
      this.props.disableProceedButton && this.props.disableProceedButton();
      this.setState(
        { isLoading: true, clickedCouponCode: couponCode },
        () =>
          global.AccessType &&
          global.AccessType.validateVoucher({
            subscriptionPlanId: selectedPlanId,
            voucher: couponCode
          })
            .then(response => {
              this.setState({ isLoading: false, clickedCouponCode: '' });
              response.valid
                ? setAppliedCoupon(response)
                : handleInvalidCoupon(response, couponCode);
              this.props.enableProceedButton && this.props.enableProceedButton();

              this.props.enablePlanSelection && this.props.enablePlanSelection();
            })
            .catch(() => {
              this.setState({ isLoading: false, clickedCouponCode: '' });
              handleInvalidCoupon(undefined, couponCode);
              this.props.enableProceedButton && this.props.enableProceedButton();
              this.props.enablePlanSelection && this.props.enablePlanSelection();
            })
      );
    }
  }

  couponDisabled(appliedCouponCode, disableCoupons, couponCode) {
    return couponCode === appliedCouponCode || disableCoupons;
  }

  render() {
    const {
      theme,
      appliedCoupon,
      setAppliedCoupon,
      handleInvalidCoupon,
      selectedPlan,
      disableCoupons,
      coupons = []
    } = this.props;
    const themePrefix = theme ? 'white-' : '';
    const selectedPlanId = selectedPlan ? selectedPlan.id : null;
    return (
      <div styleName="coupon-scroll-box-subcontainer">
        <h3 styleName={`${themePrefix}offers-title`}>Offers For You</h3>
        <div styleName={`${themePrefix}scroll-box-container scroll-box-container`}>
          <div
            styleName={`${themePrefix}coupons-container coupons-container`}
            data-testid="coupon-offer"
          >
            {coupons.map(coupon => {
              return (
                <Coupon
                  couponCode={coupon.code}
                  isLoading={this.state.isLoading && coupon.code === this.state.clickedCouponCode}
                  couponOnClick={() =>
                    this.couponOnClick(
                      selectedPlanId,
                      coupon.code,
                      setAppliedCoupon,
                      handleInvalidCoupon
                    )
                  }
                  couponDetail={get(coupon, ['metadata', 'description'], '')}
                  key={coupon.code}
                  themePrefix={themePrefix}
                  isDisabled={
                    this.state.isLoading ||
                    this.couponDisabled(
                      get(appliedCoupon, ['discount_details', 'code']),
                      disableCoupons,
                      coupon.code
                    )
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

CouponScrollBox.propTypes = {
  coupons: PropTypes.array.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  setAppliedCoupon: PropTypes.func.isRequired,
  appliedCoupon: PropTypes.object,
  theme: PropTypes.bool,
  handleInvalidCoupon: PropTypes.func.isRequired,
  disableCoupons: PropTypes.bool,
  disablePlanSelection: PropTypes.func,
  enablePlanSelection: PropTypes.func,
  disableProceedButton: PropTypes.func,
  enableProceedButton: PropTypes.func
};

export default CouponScrollBox;
